// extracted by mini-css-extract-plugin
module.exports = {"scroll":"_1ElzP","dimensions":"_1wQiO","show":"_1tjwL","hide":"_4aAQS"};